var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[(_vm.layout)?[_c('keep-alive',[_c(_vm.layout,{tag:"component"})],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }